import { inject, Navigator, needs } from "fw";
import { CurrentUserStore } from "state/current-user";
import { LoginForm } from "./login-form";

@inject
@needs(LoginForm)
export class Login {
    private redirectTo = "";
    private showTwoFactor = false;
    public openForgotPassword: boolean = false;

    constructor(
        private currentUser: CurrentUserStore,
        private nav: Navigator
    ) {}

    activate(data) {
        if (data && data.redirect) {
            this.redirectTo = data.redirect;
        }

        if (data && data["forgot-password"]) {
            this.openForgotPassword = true;
        }

        if (this.currentUser && this.currentUser.state.loggedIn) this.loggedIn();
    }

    loggedIn() {
        this.nav.navigate(this.redirectTo);
    }
}
